module.exports = __webpack_public_path__ + "static/media/ftn-nordea-auth.dc3bf84b.svg";